
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/excavation-and-structural-construction-sydney/bulk-detailed-excavation-sydney",
      function () {
        return require("private-next-pages/services/excavation-and-structural-construction-sydney/bulk-detailed-excavation-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/excavation-and-structural-construction-sydney/bulk-detailed-excavation-sydney"])
      });
    }
  